<template>
<div class="grid p-fluid">
	<template v-if="loader==true">
		<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em" />
		</div>
	</template>
	<div class="col-12 lg:col-12">
		<ScrollPanel>
			<TabView @tab-click="handleTabChange">
				<TabPanel header="Detalles">
					<DetalleMovimiento :InfoDetalleMov="info_detalle_mov" :info_actores="info_actores"/> 
				</TabPanel>
				<TabPanel header="Resultado PESV">
					<InspeccionVehicular :inspeccion_vehicular="inspeccion_vehicular" :fecha_inspeccion="fecha_inspeccion" :num_movimiento="num_movimiento" :id_deliverie="id_deliverie" :datos_vehiculo="datos_vehiculo" :loader="loader" :IdCustomer="IdCustomer" />
				</TabPanel>
				<TabPanel header="Documentos">
					<DocumentosMovimiento :Documentos="documentos" />
				</TabPanel>
				<TabPanel header="Actores">
					<ActoresMovimientos :img_vehiculo="img_vehiculo" :img_conductor="img_conductor" :Customer="customers" />
				</TabPanel>
				<TabPanel header="Temperaturas">
					<Temperaturas :Customer="customers" :temperaturas_sigueme="temperaturas_sigueme ?? 0" :id_viaje="id_viaje" :IdCustomer="IdCustomer" :vista_temperatura="vista_temperatura" />
				</TabPanel>
			</TabView>
			</ScrollPanel>
		</div>
  </div>
</template>

<script>
import DetalleMovimiento from './DetalleMovimiento.vue'
import DocumentosMovimiento from './DocumentosMovimiento.vue'
import InspeccionVehicular from './InspeccionVehicular.vue'
import ActoresMovimientos from './ActoresMovimientos.vue'
import Temperaturas from './Temperaturas.vue'
import Eventos from './Eventos.vue';
export default {
	data() {
		return {
			message: [],
			info_detalle_mov: null,
			documentos: null,
			inspeccion_vehicular: null,
			fecha_inspeccion: null,
			activeIndex: 0,
			customers: [],
			detalle_reme: [],
			details_remesa: [],
			code_seway: '',
			code_cumplido: '',
			vista_temperatura: 0,
			list_cumplidos: [],
			list_sucursales: [],
			info_actores: [],
			img_conductor: [],
			data_fila: [],
			img_vehiculo: [],
			img_conductor: [],
			datos_vehiculo: [],
			list_eventos: [],
			temperaturas_sigueme: [],
			loader: false,
			loading: false,
		}
	},
	props: ['variableProp','id_deliverie','IdCustomer','Placa','conductor_documento','num_movimiento','id_viaje'],
  	mounted(){
		
		this.loadGeneradores();
	},
	methods:{
		handleTabChange(event) {
            switch (event.index) {
                case 0:
                    console.log('a');
                    break;
                case 1:
					this.traer_inspeccion();
                    break;
                case 2:
					this.traer_documentos();
                    break;
				case 3:
					this.traer_actores();
                    break;
				case 4:
					this.cargarTemperaturas();
                    break;
				case 5:
					this.traer_eventos();
                    break;
                default:
                    break;
            }
        },
		async loadGeneradores() {
			if (this.loader == true) {
				this.$toast.add({severity:'warn', summary: 'Cargando información', detail:'por favor espere', life: 4000});
				return
			}
			this.info_detalle_mov = null;
			this.fecha_inspeccion = null;
			var _that = this;
			this.loader = true;
			
			var url = 'detalle_mov_transporte';
			window.api.call('post', url, {id_customer: this.IdCustomer,movimiento_id: this.variableProp,id_deliverie: this.id_deliverie,placa: this.Placa,conductor_documento: this.conductor_documento}).then( function(response) {
				if(response.status == 200){
					_that.info_detalle_mov = response.data.data_total;
					_that.datos_vehiculo = response.data.datos_vehiculo;
					_that.loader = false;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
		traer_inspeccion(){
			this.inspeccion_vehicular = null;
			var _that = this;
			this.loader = true;
			var url = 'traerchecklist';
			window.api.call('post', url, {id_customer: this.IdCustomer,id_deliverie: this.id_deliverie}).then( function(response) {
				if(response.status == 200){
					if (response.data.inspeccion_vehicular!=null) {
						_that.inspeccion_vehicular = response.data.inspeccion_vehicular.checklist_categories;
						_that.fecha_inspeccion = response.data.inspeccion_vehicular.checklist_general_date ?? '';
					}
					_that.loader = false;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
				if (err.status==414) {
					_that.$toast.add({severity:'warn', summary: 'Falta información', detail:err.data.message, life: 4000});
				}

			});
		},
		traer_documentos(){
			this.documentos = null;
			var _that = this;
			this.loader = true;
			var url = 'traer_documentos';
			window.api.call('post', url, {id_customer: this.IdCustomer,movimiento_id: this.variableProp}).then( function(response) {
				if(response.status == 200){
					_that.documentos = response.data.documentos;
					_that.loader = false;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
				
				
			});
		},
		traer_actores(){
			this.documentos = null;
			var _that = this;
			this.loader = true;
			var url = 'traer_actores';
			window.api.call('post', url, {id_customer: this.IdCustomer,movimiento_id: this.variableProp,placa: this.Placa,conductor_documento: this.conductor_documento}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.img_vehiculo = response.data.img_vehiculo;
					_that.img_conductor = response.data.img_conductor;
					_that.customers = response.data.data;

				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
		async cargarTemperaturas(){
			this.temperaturas_sigueme = [];
			this.loader = true;
			var _that = this;
			var url = 'cargar_sigueme_temperaturas';
			window.api.call('post', url, {id_customer: this.IdCustomer,id_viaje: this.id_viaje}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					if (response.data.data.success==false) {
						_that.$toast.add({severity:'error', summary: 'Error', detail:response.data.data.message, life: 4000});
					}else{
						_that.$toast.add({ severity: 'success', summary: 'Temperaturas:', detail: response.data.data.message, life: 6000 });
						_that.temperaturas_sigueme = response.data.array_temperaturas;
						_that.vista_temperatura = response.data.vista_temperatura;
					}
					
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
		traer_eventos(){
			this.list_eventos = null;
			var _that = this;
			this.loader = true;
			var url = 'traer_eventos';
			window.api.call('post', url, {id_customer: this.IdCustomer,id_deliverie: this.id_deliverie}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.list_eventos = response.data.data;
					_that.code_seway = response.data.code;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
	},
	components: {
        'DetalleMovimiento': DetalleMovimiento,
        'DocumentosMovimiento': DocumentosMovimiento,
        'InspeccionVehicular': InspeccionVehicular,
        'ActoresMovimientos': ActoresMovimientos,
        'Temperaturas': Temperaturas,
        'Eventos': Eventos
    },
};
</script>